module.exports = __webpack_public_path__ + "static/media/LB_02.67d5ad86.jpg";